/** People Landing — campos del bloque "embed". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { EditorFieldProps } from '../types';

export function EmbedFields({ draft, set }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.embed_title', 'Título (opcional)')}</Label>
        <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
      </div>
      <div className="space-y-1.5">
        <Label>URL</Label>
        <Input
          value={draft.url ?? ''}
          onChange={(e) => set({ url: e.target.value })}
          placeholder="https://www.youtube.com/embed/… · https://drive.google.com/file/d/…/preview"
        />
        <p className="text-xs text-muted-foreground">
          {t(
            'people_landing.editor.embed_hint',
            'YouTube: usá el link de "Insertar" (/embed/). Drive: link del archivo terminado en /preview.'
          )}
        </p>
      </div>
    </>
  );
}
